import { render, staticRenderFns } from "./ShippingDetailsForm.vue?vue&type=template&id=c13dae5e&scoped=true"
import script from "./ShippingDetailsForm.vue?vue&type=script&lang=js"
export * from "./ShippingDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./ShippingDetailsForm.vue?vue&type=style&index=0&id=c13dae5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13dae5e",
  null
  
)

export default component.exports